import { Link } from "react-router-dom";
import { hubFor } from "../data/seo";

/** Home > section hub > page. Features sit at the root, so they get two levels. */
export default function Breadcrumb({ entry }) {
  const hub = entry.type === "hub" ? null : hubFor(entry.type);
  return (
    <nav className="tpl-crumbs" aria-label="Breadcrumb">
      <ol>
        <li>
          <Link to="/">Home</Link>
        </li>
        {hub && (
          <li>
            <Link to={hub.path}>{hub.label}</Link>
          </li>
        )}
        <li aria-current="page">{entry.h1}</li>
      </ol>
    </nav>
  );
}
